import { action } from "satcheljs";
import type { SearchScenarioId } from "owa-search-store";

export interface ON_ESCAPE_PRESSED_SEARCH_INPUTActionMessage {
    scenarioId: SearchScenarioId;
}
export const onEscapePressedSearchInput: (scenarioId: SearchScenarioId) => ON_ESCAPE_PRESSED_SEARCH_INPUTActionMessage = action("ON_ESCAPE_PRESSED_SEARCH_INPUT", (scenarioId: SearchScenarioId): ON_ESCAPE_PRESSED_SEARCH_INPUTActionMessage => ({ scenarioId }));
